<p-toast></p-toast>
<div class="card mt-2" *ngIf="listImagePathJE && showListImageJE">
    <h5 class="mt-0">{{'JE_ATTACHMENTS'| translate}}</h5>
    <div class="p-fluid p-formgrid grid">
        <div *ngFor="let image of listImagePathJE; let index = index;" class="field m-3"
            key="index">
            <img [src]="image.ImagePath" [alt]="image.DocumentType" style="cursor: pointer"
                (click)="imageClick(index, 'JE')" style="max-width: 300px; max-height: 300px;" />
            <div class="flex flex-wrap justify-content-center">
                <div>{{image.DocumentType}}</div>
            </div>
        </div>
    </div>
</div>

<div class="card mt-2" *ngIf="listImagePathSDO && showListImageSDO">
    <h5 class="mt-0">{{'SDO_ATTACHMENTS'| translate}}</h5>
    <div class="p-fluid p-formgrid grid">
        <div *ngFor="let image of listImagePathSDO; let index = index;" class="field m-3"
            key="index">
            <img [src]="image.ImagePath" [alt]="image.DocumentType" style="cursor: pointer"
                (click)="imageClick(index, 'SDO')" style="max-width: 300px; max-height: 300px;" />
            <div class="flex flex-wrap justify-content-center">
                <div>{{image.DocumentType}}</div>
            </div>
        </div>
    </div>
</div>

<div class="card mt-2" *ngIf="listImagePathXEN && showListImageXEN">
    <h5 class="mt-0">{{'XEN_ATTACHMENTS'| translate}}</h5>
    <div class="p-fluid p-formgrid grid">
        <div *ngFor="let image of listImagePathXEN; let index = index;" class="field m-3"
            key="index">
            <img [src]="image.ImagePath" [alt]="image.DocumentType" style="cursor: pointer"
                (click)="imageClick(index, 'XEN')" style="max-width: 300px; max-height: 300px;" />
            <div class="flex flex-wrap justify-content-center">
                <div>{{image.DocumentType}}</div>
            </div>
        </div>
    </div>
</div>
<div class="card mt-2" >
    <button (click)="onImageFormGoBack()" pButton pRipple type="button" label="Back"
        class="p-button-success mr-2 mb-2"></button>
    <button (click)="onImageFormSubmit()" pButton pRipple type="button" label="Save & Next"
        class="p-button-success mr-2 mb-2"></button>
</div>
<p-galleria [value]="listImagePathJE" [(visible)]="displayCustomJE" [(activeIndex)]="activeIndex"
    [responsiveOptions]="responsiveOptions" [containerStyle]="{'max-width': '850px'}" [circular]="true"
    [fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false" [baseZIndex]="100000">
    <ng-template pTemplate="item" let-item>
        <img [src]="item.ImagePath" style="width: 100%; display: block;" />
    </ng-template>
    <!-- <ng-template pTemplate="thumbnail" let-item>
        <div class="grid grid-nogutter justify-content-center">
            <img [src]="item.ImagePath" style="display: block;" />
        </div>
    </ng-template> -->
</p-galleria>

<p-galleria [value]="listImagePathXEN" [(visible)]="displayCustomXEN" [(activeIndex)]="activeIndex"
    [responsiveOptions]="responsiveOptions" [containerStyle]="{'max-width': '850px'}" [circular]="true"
    [fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false" [baseZIndex]="100000">
    <ng-template pTemplate="item" let-item>
        <img [src]="item.ImagePath" style="width: 100%; display: block;" />
    </ng-template>
</p-galleria>

<p-galleria [value]="listImagePathSDO" [(visible)]="displayCustomSDO" [(activeIndex)]="activeIndex"
    [responsiveOptions]="responsiveOptions" [containerStyle]="{'max-width': '850px'}" [circular]="true"
    [fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false" [baseZIndex]="100000">
    <ng-template pTemplate="item" let-item>
        <img [src]="item.ImagePath" style="width: 100%; display: block;" />
    </ng-template>
</p-galleria>

<p-galleria [value]="images" [(visible)]="displayCustom" [(activeIndex)]="activeIndex"
    [responsiveOptions]="responsiveOptions" [containerStyle]="{'max-width': '850px'}" [circular]="true"
    [fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false" [baseZIndex]="100000">
    <ng-template pTemplate="item" let-item>
        <img [src]="item.ImagePath" style="width: 100%; display: block;" />
    </ng-template>
    <!-- <ng-template pTemplate="thumbnail" let-item>
        <div class="grid grid-nogutter justify-content-center">
            <img [src]="item.ImagePath" style="display: block;" />
        </div>
    </ng-template> -->
</p-galleria>
